import * as React from 'react';
import Svg, { SvgProps, G, Rect, Path } from 'react-native-svg';

function SvgComponent(props: SvgProps) {
  return (
    <Svg width={29} height={39} {...props}>
      <G transform="rotate(180 14 19.5)" fill="none" fillRule="evenodd">
        <Rect fill="#247A9C" x={12.976} width={1.854} height={12.049} rx={0.927} />
        <Path
          d="M13.439 38c7.422 0 13.439-6.017 13.439-13.439 0-5.796-3.669-10.734-8.81-12.62a315.265 315.265 0 00-4.167 4.095c-2.293-2.233-3.788-3.666-4.486-4.301C3.96 13.445 0 18.54 0 24.56 0 31.983 6.017 38 13.439 38z"
          stroke="#247A9C"
          strokeWidth={1.5}
        />
        <Path
          d="M23.17 28.732h-7.048v-1.205h2.82v-7.398h1.41v7.398h2.819v1.205zm-7.578 0h-1.59l-1.615-6.543h-.048l-1.699 6.543H9.182l-1.699-6.543h-.048L5.82 28.732H4.23l2.482-8.603h1.494l1.675 6.47h.048l1.687-6.47h1.506l2.47 8.603z"
          fill="#247A9C"
          fillRule="nonzero"
        />
        <Path
          d="M21.255 5.231a.5.5 0 01-.006.707l-7.076 6.972a.5.5 0 01-.51.118.498.498 0 01-.272-.147L6.54 5.679a.5.5 0 01.005-.695l.27-.275.012-.012a.5.5 0 01.707.018l6.281 6.603 6.462-6.368.07-.057a.5.5 0 01.638.063z"
          fill="#247A9C"
        />
      </G>
    </Svg>
  );
}

const AquireIcon = React.memo(SvgComponent);
export default AquireIcon;
